import { createContext, useContext } from 'react';

export interface LoginPromptOptions {
  title?: string;
  description?: string;
}

export interface LoginContextValue {
  promptLoginModal: (options?: LoginPromptOptions) => void;
  closeLoginModal: () => void;
}

export const LoginContext = createContext<LoginContextValue | undefined>(undefined);

export function useLogin(): LoginContextValue {
  const context = useContext(LoginContext);
  if (context === undefined) {
    throw new Error('useLogin must be used within a LoginProvider');
  }
  return context;
}

